module.exports = __webpack_public_path__ + "static/scale-model-of-bill-speidel's-underground-tour-in-seattle-washington-00c7eb55bb094b937d3dcdefd9247118.png";